/**
 * @property {Request} request
 * @property {?string} requestBody
 * @property {?Response} response
 * @property {string} logSource
 * @property {?string} dataSource
 * @property {boolean} doNotLog
 */
export default class RequestLogData {
  /**
   * @param {Request} request
   * @param {?string} requestBody - passed separately because `request.body` stream cannot be read again after `fetch` is called
   * @param {?Response} response
   * @param {?string} responseBody
   * @param {?string} logSource
   * @param {?string} dataSource
   * @param {?boolean} doNotLog
   */
  constructor({
    request,
    requestBody,
    response = null,
    responseBody = null,
    logSource = 'unknown',
    dataSource = null,
    doNotLog = false,
  }) {
    this.request = request;
    this.requestBody = requestBody;
    this.response = response;
    this.responseBody = responseBody;
    this.logSource = logSource;
    this.dataSource = dataSource;
    this.doNotLog = doNotLog;
  }
}
